import { AdminAuthContext as e } from "../context/AdminAuthContext.mjs";
import { useContext as t } from "react";
//#region src/hooks/useAdminAuth.ts
var n = () => {
	let n = t(e);
	if (!n) throw Error("useAdminAuth must be used inside <AdminAuthProvider>");
	return n;
};
//#endregion
export { n as useAdminAuth };
